/**
 * @file apps/web/src/lib/documentLabels.ts
 * @description Client-facing names for document types. The portal used to print
 * the raw `doc_type` ("NODE_FDD"), which is an internal identifier.
 */

const LABELS: Record<string, string> = {
  fdd:       'FDD',
  node_fdd:  'FDD',
  brd:       'BRD',
  test_plan: 'Test plan',
};

/** A readable label for a documents.doc_type; unknown types are title-cased, never shown raw. */
export function documentTypeLabel(docType: string): string {
  const known = LABELS[docType.toLowerCase()];
  if (known) return known;
  const words = docType.replace(/_/g, ' ').trim().toLowerCase().split(/\s+/).filter(Boolean);
  return words.length ? words.map((w) => w[0]!.toUpperCase() + w.slice(1)).join(' ') : 'Document';
}
